module.exports = __webpack_public_path__ + "img/gb5783-86.prt.7e92a897.jpg";